import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: 1px solid rgba(29, 29, 29, 0.1);
  border-radius: 24px;
  width: 100%;

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }

  ${({ $inHeader = false }) =>
    $inHeader &&
    css`
      height: 100%;
    `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding: 0 20px 20px 20px;
  width: 100%;

  ${({ $inHeader = false }) =>
    $inHeader &&
    css`
      flex-grow: 1;
    `}
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;

  ${({ $isNoImage }) =>
    $isNoImage
      ? css`
          width: 100%;
          height: 280px;
          border-radius: 24px;
          background-color: #cccccc2b;
          position: relative;

          &::before {
            content: attr(data-header);
            position: absolute;
            top: 25px;
            left: 25px;
            width: calc(100% - 25px * 2);
            height: calc(100% - 25px * 2);
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: ${({ theme }) => theme.fonts.primary};
            font-weight: 400;
            font-size: 16px;
            line-height: 28px;
            letter-spacing: -0.03em;
            color: rgba(29, 29, 29, 0.5);
          }
        `
      : ""};
`;

export const Tag = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 12px;
  background-color: rgba(29, 29, 29, 0.6);
  backdrop-filter: blur(15px);
  border-radius: 32px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #ffffff;
  cursor: pointer;
  position: absolute;
  left: 12px;
  bottom: 12px;
`;

export const Rating = styled.div`
  padding: 2px 12px 2px 28px;
  background-image: url("/images/icons/star-rounded.svg");
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: 8px 3px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  position: absolute;
  background-color: rgba(29, 29, 29, 0.6);
  backdrop-filter: blur(15px);
  border-radius: 32px;
  right: 12px;
  bottom: 12px;
  color: #ffffff;
`;

export const Image = styled.img`
  border-radius: 24px;
  width: 100%;
  height: 280px;
  object-fit: cover;
`;

export const Title = styled.h4`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 24px;
  line-height: 150%;
  color: rgba(29, 29, 29, 0.85);
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;

  ${({ $inHeader = false }) =>
    $inHeader &&
    css`
      white-space: normal;
      text-align: left;
    `}
`;

export const SubTitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: rgba(29, 29, 29, 0.5);
  margin-top: 8px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;

  ${({ $inHeader = false }) =>
    $inHeader &&
    css`
      white-space: normal;
      text-align: left;
    `}
`;

export const ViewGuide = styled.span`
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: #ff6030;
  margin-top: 32px;
  display: inline-block;
  display: flex;
  align-items: center;

  img {
    margin-left: 8px;
    height: 20px;
    width: 20px;
  }

  ${({ $inHeader = false }) =>
    $inHeader &&
    css`
      margin-top: auto;
    `}
`;
